export const cities = [
  {
    slug: 'boston',
    name: 'Boston',
    state: 'MA',
    tagline: 'Stay ahead of what\'s happening in your neighborhood.',
    description:
      'Sign up to receive timely alerts about street sweeping, parking restrictions, snow emergencies, and more across Boston\'s neighborhoods.',
    colors: {
      primary: '#091F40',
      secondary: '#FB4D42',
      accent: '#288BE4',
      headerBg: '#091F40',
      headerText: '#FFFFFF',
      heroBg: '#091F40',
      heroText: '#FFFFFF',
      buttonPrimary: '#FB4D42',
      buttonPrimaryText: '#FFFFFF',
      buttonSecondary: '#288BE4',
      cardAccent: '#FB4D42',
      tagBg: 'rgba(251,77,66,0.12)',
      tagText: '#B83228',
    },
    font: "'Lato', sans-serif",
    topics: [
      {
        id: 'street-sweeping',
        category: 'Transportation',
        name: 'Street Sweeping',
        description:
          'Receive advance notice before street sweeping on your block so you can move your car in time.',
        icon: '🧹',
        subscribers: 14823,
        requiresAddress: true,
      },
      {
        id: 'parking-alerts',
        category: 'Transportation',
        name: 'Parking Alerts',
        description:
          'Get notified about temporary no-parking zones, tow-away zones, and meter changes near you.',
        icon: '🅿️',
        subscribers: 8341,
        requiresAddress: true,
      },
      {
        id: 'snow-emergency',
        category: 'Emergency',
        name: 'Snow Emergency',
        description:
          'Immediate city-wide alerts when snow emergencies are declared. Know before you need to move.',
        icon: '❄️',
        subscribers: 22107,
        requiresAddress: false,
      },
      {
        id: 'road-construction',
        category: 'Transportation',
        name: 'Road Construction',
        description:
          'Stay informed about upcoming lane closures, road construction, and detours in your area.',
        icon: '🚧',
        subscribers: 5612,
        requiresAddress: true,
      },
      {
        id: 'trash-recycling',
        category: 'City Services',
        name: 'Trash & Recycling',
        description:
          'Reminders and last-minute alerts about pickup schedule changes, holidays, and special collections.',
        icon: '♻️',
        subscribers: 11234,
        requiresAddress: true,
      },
      {
        id: 'community-events',
        category: 'Community',
        name: 'Community Events',
        description:
          'Neighborhood meetings, public hearings, and community events happening near you.',
        icon: '📅',
        subscribers: 3891,
        requiresAddress: false,
      },
    ],
  },
  {
    slug: 'austin',
    name: 'Austin',
    state: 'TX',
    tagline: 'Keep Austin informed — sign up for city alerts.',
    description:
      'Get real-time alerts on road closures, special events, utility outages, and environmental notices across Austin.',
    colors: {
      primary: '#2C4770',
      secondary: '#FF6B2B',
      accent: '#00C389',
      headerBg: '#2C4770',
      headerText: '#FFFFFF',
      heroBg: '#2C4770',
      heroText: '#FFFFFF',
      buttonPrimary: '#FF6B2B',
      buttonPrimaryText: '#FFFFFF',
      buttonSecondary: '#00C389',
      cardAccent: '#FF6B2B',
      tagBg: 'rgba(255,107,43,0.12)',
      tagText: '#C04A10',
    },
    font: "'Lato', sans-serif",
    topics: [
      {
        id: 'road-closures',
        category: 'Transportation',
        name: 'Road Closures',
        description:
          'Real-time notifications about street closures, detours, and construction affecting your commute.',
        icon: '🚦',
        subscribers: 9823,
        requiresAddress: true,
      },
      {
        id: 'special-events',
        category: 'Events',
        name: 'Special Events',
        description:
          'Get advance notice about festivals, marathons, and events that may impact traffic or parking.',
        icon: '🎉',
        subscribers: 17450,
        requiresAddress: false,
      },
      {
        id: 'water-alerts',
        category: 'Utilities',
        name: 'Water Alerts',
        description:
          'Boil water notices, service interruptions, and conservation stage updates for your area.',
        icon: '💧',
        subscribers: 31204,
        requiresAddress: true,
      },
      {
        id: 'utility-outages',
        category: 'Utilities',
        name: 'Utility Outages',
        description:
          'Power outage updates, planned maintenance windows, and restoration estimates from Austin Energy.',
        icon: '⚡',
        subscribers: 24891,
        requiresAddress: true,
      },
      {
        id: 'environmental',
        category: 'Environment',
        name: 'Environmental Alerts',
        description:
          'Air quality warnings, ozone action days, heat advisories, and drought-stage restrictions.',
        icon: '🌿',
        subscribers: 7632,
        requiresAddress: false,
      },
      {
        id: 'public-safety',
        category: 'Safety',
        name: 'Public Safety',
        description:
          'Neighborhood safety notices, missing persons alerts, and shelter-in-place notifications.',
        icon: '🚨',
        subscribers: 41009,
        requiresAddress: false,
      },
    ],
  },
  {
    slug: 'denver',
    name: 'Denver',
    state: 'CO',
    tagline: 'Mile High alerts — always in the know.',
    description:
      'Stay on top of snow operations, street sweeping, recreation programs, and city services across Denver neighborhoods.',
    colors: {
      primary: '#003A63',
      secondary: '#CF4520',
      accent: '#78BE20',
      headerBg: '#003A63',
      headerText: '#FFFFFF',
      heroBg: '#003A63',
      heroText: '#FFFFFF',
      buttonPrimary: '#CF4520',
      buttonPrimaryText: '#FFFFFF',
      buttonSecondary: '#78BE20',
      cardAccent: '#CF4520',
      tagBg: 'rgba(207,69,32,0.12)',
      tagText: '#9A3418',
    },
    font: "'Lato', sans-serif",
    topics: [
      {
        id: 'snow-operations',
        category: 'Emergency',
        name: 'Snow Operations',
        description:
          'Know when snow plows are coming to your street and when snow emergency routes are activated.',
        icon: '🌨️',
        subscribers: 28445,
        requiresAddress: true,
      },
      {
        id: 'street-sweeping',
        category: 'Transportation',
        name: 'Street Sweeping',
        description:
          'Advance notice before street sweeping days so you can move your vehicle and avoid tickets.',
        icon: '🧹',
        subscribers: 12300,
        requiresAddress: true,
      },
      {
        id: 'parking-restrictions',
        category: 'Transportation',
        name: 'Parking Restrictions',
        description:
          'Temporary restrictions, event parking zones, and residential permit program updates.',
        icon: '🅿️',
        subscribers: 6789,
        requiresAddress: true,
      },
      {
        id: 'recreation-programs',
        category: 'Community',
        name: 'Recreation Programs',
        description:
          'Registration openings, facility closures, and program updates for Denver Parks & Recreation.',
        icon: '🏔️',
        subscribers: 9102,
        requiresAddress: false,
      },
      {
        id: 'utility-maintenance',
        category: 'Utilities',
        name: 'Utility Maintenance',
        description:
          'Planned water, sewer, and gas service interruptions in your neighborhood.',
        icon: '🔧',
        subscribers: 15567,
        requiresAddress: true,
      },
      {
        id: 'city-meetings',
        category: 'Community',
        name: 'City Council & Meetings',
        description:
          'Agendas, schedule changes, and results from Denver City Council and neighborhood board meetings.',
        icon: '🏛️',
        subscribers: 2890,
        requiresAddress: false,
      },
    ],
  },
];

export function getCityBySlug(slug) {
  return cities.find((c) => c.slug === slug) || null;
}

export const CATEGORIES = ['All', 'Transportation', 'Emergency', 'City Services', 'Community', 'Utilities', 'Events', 'Environment', 'Safety'];
